import { render, staticRenderFns } from "./Lpqv.vue?vue&type=template&id=560e2a74&"
import script from "./Lpqv.vue?vue&type=script&lang=js&"
export * from "./Lpqv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports